import {Icon} from '@buncha/components/core/icon';
import * as React from 'react';
import {SvgProps, Path} from 'react-native-svg';
const AlertIcon = (props: SvgProps) => (
  <Icon {...props}>
    <Path
      fill={props.fill}
      d="M14.078 10.904 8.954 2.006a1.684 1.684 0 0 0-2.908 0L.922 10.904a1.608 1.608 0 0 0 0 1.624 1.659 1.659 0 0 0 1.454.831h10.248a1.659 1.659 0 0 0 1.673-1.643c0-.285-.075-.565-.22-.812Zm-1.219.92a.261.261 0 0 1-.234.13H2.376a.261.261 0 0 1-.234-.13.209.209 0 0 1 0-.218l5.124-8.899a.28.28 0 0 1 .468 0l5.124 8.899a.208.208 0 0 1 .001.218ZM6.797 7.97V6.094a.703.703 0 1 1 1.406 0v1.875a.703.703 0 0 1-1.406 0Zm1.64 2.343a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.875 0Z"
    />
  </Icon>
);
export default AlertIcon;
